(() => {
  const initialise = () => {
    const root = document.querySelector('.epic-menu-design');
    if (!root || root.dataset.menuReady) return;
    root.dataset.menuReady = 'true';
    const panels = Array.from(root.querySelectorAll('.epic-menu-panel'));
    const triggers = Array.from(root.querySelectorAll('.submenu-trigger'));
    const brands = Array.isArray(window.brandCollections) ? window.brandCollections : [];
    const search = root.querySelector('[data-menu-brand-search]');
    const brandGrid = root.querySelector('.epic-menu-brands');
    const brandCount = root.querySelector('[data-menu-brand-count]');
    const empty = root.querySelector('[data-menu-brand-empty]');
    const smallScreen = window.matchMedia('(max-width: 999px)');
    const hoverScreen = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 1000px)');
    const sliderInstances = new Map();
    const normalise = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    let activePanel = null;
    let activeTrigger = null;
    let letterFilter = null;
    let brandType = 'all';
    let closeTimer;
    let searchTimer;
    let mobileLock = null;
    let positionFrame = null;
    const section = root.closest('.shopify-section') || root;
    const jbarMenu = document.getElementById('menuContainer');
    const saveStyles = (element, properties) => properties.map(name => [name, element.style.getPropertyValue(name), element.style.getPropertyPriority(name)]);
    const restoreStyles = (element, styles) => styles.forEach(([name, value, priority]) => {
      if (value) element.style.setProperty(name, value, priority);
      else element.style.removeProperty(name);
    });
    const setMenuProperty = (name, value) => {
      if (section.style.getPropertyValue(name) !== value) section.style.setProperty(name, value);
    };
    const lockMobileMenu = () => {
      if (mobileLock) return;
      const placeholder = document.createElement('div');
      const sectionStyle = getComputedStyle(section);
      placeholder.setAttribute('aria-hidden', 'true');
      placeholder.style.height = section.getBoundingClientRect().height + 'px';
      placeholder.style.marginTop = sectionStyle.marginTop;
      placeholder.style.marginBottom = sectionStyle.marginBottom;
      mobileLock = {
        x: window.scrollX,
        y: window.scrollY,
        placeholder,
        styles: saveStyles(document.body, ['position', 'top', 'left', 'right', 'width', 'overflow'])
      };
      section.before(placeholder);
      document.documentElement.classList.add('epic-menu-page-locked');
      Object.assign(document.body.style, {
        position: 'fixed', top: -mobileLock.y + 'px', left: '0', right: '0', width: '100%', overflow: 'hidden'
      });
      section.classList.add('epic-menu-mobile-open');
    };
    const unlockMobileMenu = () => {
      if (!mobileLock) return;
      const saved = mobileLock;
      mobileLock = null;
      section.classList.remove('epic-menu-mobile-open', 'epic-menu-short-viewport');
      section.style.removeProperty('--epic-menu-viewport-top');
      section.style.removeProperty('--epic-menu-mobile-height');
      saved.placeholder.remove();
      restoreStyles(document.body, saved.styles);
      const html = document.documentElement;
      const behavior = saveStyles(html, ['scroll-behavior']);
      html.style.setProperty('scroll-behavior', 'auto', 'important');
      document.documentElement.classList.remove('epic-menu-page-locked');
      window.scrollTo({left: saved.x, top: saved.y, behavior: 'instant'});
      restoreStyles(html, behavior);
    };
    const positionMenu = () => {
      if (activePanel && smallScreen.matches) {
        lockMobileMenu();
        const viewport = window.visualViewport;
        if (viewport && Math.abs(viewport.scale - 1) > .02) return;
        const top = Math.max(0, viewport?.offsetTop || 0);
        const viewportBottom = top + (viewport?.height || window.innerHeight);
        const bar = jbarMenu?.getBoundingClientRect();
        const barVisible = bar && bar.height > 0 && bar.top > top && bar.top < viewportBottom && getComputedStyle(jbarMenu).visibility !== 'hidden';
        const bottom = barVisible ? Math.min(viewportBottom, bar.top) - 8 : viewportBottom - 8;
        const available = Math.max(0, Math.floor(bottom - top));
        setMenuProperty('--epic-menu-viewport-top', top + 'px');
        setMenuProperty('--epic-menu-mobile-height', available + 'px');
        section.classList.toggle('epic-menu-short-viewport', available < 460);
      } else {
        unlockMobileMenu();
        root.style.setProperty('--epic-menu-top', Math.max(0, section.getBoundingClientRect().bottom) + 'px');
        root.style.setProperty('--epic-menu-center', (document.documentElement.clientWidth / 2 - section.getBoundingClientRect().left) + 'px');
      }
    };
    const schedulePosition = () => {
      if (positionFrame !== null) return;
      positionFrame = requestAnimationFrame(() => { positionFrame = null; positionMenu(); });
    };
    const slider = (element, gap = 8) => {
      if (!element) return;
      if (!sliderInstances.has(element)) {
        sliderInstances.set(element, new Swiper(element, {
          slidesPerView: 'auto', freeMode: true, spaceBetween: gap, a11y: false,
          touchEventsTarget: 'container', touchReleaseOnEdges: true, watchOverflow: true,
          navigation: {nextEl: element.querySelector('.nav_right_indicator'), disabledClass: 'opacity-0'}
        }));
      } else sliderInstances.get(element).update();
    };
    const updateSliders = panel => {
      panel.querySelectorAll('.epic-menu-tabs,.epic-menu-subtabs').forEach(element => {
        if (element.getClientRects().length) slider(element, element.classList.contains('epic-menu-tabs') ? 8 : 5);
      });
    };
    const close = (restoreFocus = false) => {
      clearTimeout(closeTimer);
      panels.forEach(panel => { panel.style.display = 'none'; });
      triggers.forEach(trigger => {
        trigger.classList.remove('active-menu-item');
        trigger.setAttribute('aria-expanded', 'false');
      });
      const previousTrigger = activeTrigger;
      activePanel = null;
      activeTrigger = null;
      unlockMobileMenu();
      if (restoreFocus && previousTrigger) previousTrigger.focus({preventScroll:true});
    };
    const selectSubGroup = button => {
      const group = button.closest('.epic-menu-group');
      if (!group) return;
      group.querySelectorAll('.epic-menu-subtab').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      group.querySelectorAll('.epic-menu-subgroup').forEach(item => {
        item.style.display = item.dataset.subSubMenuId === button.dataset.subMenuId ? 'block' : 'none';
      });
    };
    const selectGroup = button => {
      const panel = button.closest('.epic-menu-panel');
      panel.querySelectorAll('.epic-menu-tab[data-menu-link-id]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      const others = panel.querySelector('.epic-menu-others');
      if (others) others.style.display = button.classList.contains('epic-menu-brand-tab') ? 'none' : 'flex';
      panel.querySelectorAll('.epic-menu-group').forEach(group => {
        const selected = group.dataset.topLevelMenuId === button.dataset.menuLinkId;
        group.style.display = selected ? 'block' : 'none';
        if (selected) {
          const first = group.querySelector('.epic-menu-subtab');
          if (first) selectSubGroup(first);
        }
      });
      updateSliders(panel);
    };
    const brandCard = brand => {
      const cell = document.createElement('div');
      cell.className = 'epic-menu-brand-cell';
      cell.dataset.name = brand.title;
      const link = document.createElement('a');
      link.className = 'collection-item epic-menu-brand-card';
      link.href = brand.url;
      link.setAttribute('aria-label', brand.title);
      const logo = document.createElement('span');
      logo.className = 'epic-menu-brand-logo';
      const fallback = () => { const name = document.createElement('span'); name.textContent = brand.title; logo.replaceChildren(name); };
      if (brand.logoUrl) {
        const image = document.createElement('img');
        image.src = brand.logoUrl;
        image.alt = '';
        image.width = 164;
        image.height = 48;
        image.loading = 'lazy';
        image.addEventListener('error', fallback, {once:true});
        logo.append(image);
      } else fallback();
      link.append(logo);
      if ((brand.brandTypes || []).includes('Mens')) {
        const badge = document.createElement('span');
        badge.className = 'epic-menu-brand-badge';
        badge.textContent = root.dataset.menuMenLabel;
        link.append(badge);
      }
      cell.append(link);
      return cell;
    };
    const showBrands = (target, list) => {
      if (!target) return;
      const fragment = document.createDocumentFragment();
      list.forEach(brand => fragment.append(brandCard(brand)));
      target.replaceChildren(fragment);
    };
    const filterBrands = () => {
      const words = normalise(search.value).trim().split(/\s+/).filter(Boolean);
      const list = brands.filter(brand => {
        const types = brand.brandTypes || [];
        let category = brand.excludeFromAll !== 'true';
        if (brandType === 'Ladies Haircare') category = types.includes('Haircare') && !types.includes('Mens');
        else if (brandType === 'Mens Haircare') category = types.includes('Haircare') && types.includes('Mens');
        else if (brandType !== 'all') category = types.includes(brandType);
        const name = normalise(brand.title);
        const letter = name.charAt(0).toUpperCase();
        return category && (!letterFilter || letterFilter.includes(letter)) && words.every(word => name.includes(word));
      });
      showBrands(brandGrid, list);
      brandCount.textContent = list.length === 1 ? brandCount.dataset.singular : brandCount.dataset.copy.replace('__count__', list.length);
      empty.hidden = Boolean(list.length);
      root.querySelectorAll('.epic-menu-type').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.brandType === brandType)));
      root.querySelectorAll('.epic-menu-letter').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.group === letterFilter)));
      root.querySelector('.epic-menu-brand-list').scrollTop = 0;
    };
    const open = trigger => {
      const panel = panels.find(item => item.dataset.submenuId === trigger.dataset.submenuId);
      if (!panel) return;
      if (panel === activePanel) { close(); return; }
      clearTimeout(closeTimer);
      if (smallScreen.matches && document.querySelector('#jBar.epic-jbar-open')) window.AE?.close?.();
      panels.forEach(item => { item.style.display = 'none'; });
      triggers.forEach(item => {
        item.classList.remove('active-menu-item');
        item.setAttribute('aria-expanded', 'false');
      });
      activePanel = panel;
      activeTrigger = trigger;
      panel.style.display = 'flex';
      trigger.classList.add('active-menu-item');
      trigger.setAttribute('aria-expanded', 'true');
      const first = panel.querySelector('.epic-menu-tab[data-menu-link-id]');
      if (first) selectGroup(first);
      else if (panel.dataset.submenuId === '0') filterBrands();
      else { const others = panel.querySelector('.epic-menu-others'); if (others) others.style.display = 'flex'; }
      positionMenu();
      updateSliders(panel);
    };

    panels.forEach(panel => {
      panel.id = 'epic-menu-panel-' + panel.dataset.submenuId;
      panel.style.display = 'none';
      const closeButton = panel.querySelector('.epic-menu-close');
      if (closeButton) closeButton.addEventListener('click', () => close(true));
    });
    triggers.forEach(trigger => {
      trigger.setAttribute('aria-controls', 'epic-menu-panel-' + trigger.dataset.submenuId);
      trigger.addEventListener('click', () => open(trigger));
    });
    root.querySelectorAll('.epic-menu-tab[data-menu-link-id]').forEach(button => button.addEventListener('click', () => selectGroup(button)));
    root.querySelectorAll('.epic-menu-subtab').forEach(button => button.addEventListener('click', () => selectSubGroup(button)));
    root.querySelectorAll('.epic-menu-type').forEach(button => button.addEventListener('click', () => {
      clearTimeout(searchTimer);
      brandType = button.dataset.brandType;
      letterFilter = null;
      filterBrands();
    }));
    root.querySelectorAll('.epic-menu-letter').forEach(button => button.addEventListener('click', () => {
      clearTimeout(searchTimer);
      letterFilter = letterFilter === button.dataset.group ? null : button.dataset.group;
      filterBrands();
    }));
    search.addEventListener('input', () => { clearTimeout(searchTimer); searchTimer = setTimeout(filterBrands, 100); });
    root.addEventListener('mouseenter', () => clearTimeout(closeTimer));
    root.addEventListener('mouseleave', () => { if (hoverScreen.matches && activePanel) closeTimer = setTimeout(() => close(), 600); });
    document.addEventListener('click', event => { if (activePanel && !root.contains(event.target)) close(); }, true);
    document.addEventListener('keydown', event => { if (event.key === 'Escape' && activePanel) { event.preventDefault(); close(true); } });
    document.querySelectorAll('.epic-menu-back').forEach(button => button.addEventListener('click', () => window.history.back()));
    window.addEventListener('resize', schedulePosition, {passive:true});
    window.addEventListener('scroll', schedulePosition, {passive:true});
    window.visualViewport?.addEventListener('resize', schedulePosition, {passive:true});
    window.visualViewport?.addEventListener('scroll', schedulePosition, {passive:true});
    const menuResize = new ResizeObserver(schedulePosition);
    menuResize.observe(section);
    if (jbarMenu) menuResize.observe(jbarMenu);
    root.addEventListener('focusin', schedulePosition);
    root.addEventListener('focusout', schedulePosition);
    window.addEventListener('pagehide', () => close());
    window.addEventListener('pageshow', event => { if (event.persisted) close(); });
    slider(root.querySelector('.epic-menu-slider'), 0);
    showBrands(root.querySelector('.epic-menu-beauty-brands'), brands.filter(brand => (brand.brandTypes || []).includes('Beauty')));
    showBrands(root.querySelector('.epic-menu-men-brands'), brands.filter(brand => (brand.brandTypes || []).includes('Mens')));
    showBrands(root.querySelector('.epic-menu-haircare-brands'), brands.filter(brand => (brand.brandTypes || []).includes('Haircare')));
    showBrands(root.querySelector('.epic-menu-tools-brands'), brands.filter(brand => (brand.brandTypes || []).some(type => type === 'Electrical' || type === 'Tools')));
    filterBrands();
    positionMenu();
    const requested = new URLSearchParams(window.location.search).get('menu');
    if (requested) {
      const trigger = triggers.find(item => normalise(item.textContent).includes(normalise(requested)));
      if (trigger) open(trigger);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise);
  else initialise();
  document.addEventListener('shopify:section:load', initialise);
})();



